import { AUTH_CONFIG } from './auth.config';

// Chỉ nhận relative path hoặc URL /oauth/authorize của chính SSO backend.
// Không decode ở đây: giá trị đã được URLSearchParams decode một lần.
export function resolveSafeRedirect(raw: string | null | undefined, fallback: string): string {
    const value = (raw || '').trim();
    if (!value) {
        return fallback;
    }

    if (value.startsWith('/') && !value.startsWith('//') && !value.startsWith('/\\')) {
        return value;
    }

    try {
        const url = new URL(value);
        const ssoOrigin = new URL(AUTH_CONFIG.ssoBaseUrl).origin;
        if (url.origin === ssoOrigin && url.pathname === '/oauth/authorize') {
            return url.toString();
        }
    } catch {
        return fallback;
    }

    return fallback;
}
